import FuseSvgIcon from '@fuse/core/FuseSvgIcon'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, Typography } from '@mui/material'
import React from 'react'

export default function Decline(props) {
    const { open, onClose, content } = props;
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
        <DialogContent classes={{ root: "p-16 sm:p-24" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <FuseSvgIcon size={48}>heroicons-outline:check</FuseSvgIcon>
          </Box>
          <DialogContentText id="alert-dialog-description" align="center">
            <Typography variant="h5">{content}</Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
  )
}
